<template>
  <v-dialog v-model="openDialog" max-width="500" persistent>
    <div class="content-container">
      <h2>{{ orderItem.name }}</h2>
      <p class="remaining-tickets">
        Odaberi min. {{ orderItem.itemMeta.min || 0 }} - {{ orderItem.itemMeta.max || 10 }} ulaznica
      </p>
      <p>{{ orderItem.description }}</p>
      <div class="ticket-container">
        <p class="price">{{ Number(orderItem.price).toFixed(2) }} {{ orderItem.currency }}</p>
        <div class="top-buttons">
          <v-icon
            class="material-icons cursor-pointer"
            :size="43"
            color="#333"
            :disabled="ticketQuantity === 0"
            @click="decreaseTicketNum"
          >
            remove_circle
          </v-icon>
          <span class="ticket-number">{{ ticketQuantity }}</span>
          <v-icon
            class="material-icons cursor-pointer"
            :size="43"
            :disabled="disableIncreaseButton"
            color="#333"
            @click="increaseTicketNum"
          >
            add_circle
          </v-icon>
        </div>
      </div>
      <div class="bottom-buttons">
        <main-button flat color="#333" @click="handleCancelAction">Odustani</main-button>
        <div id="add-button-wrapper">
          <main-button
            color="#333"
            style="width: 100%"
            :disabled="numberOfNeededTickets > 0"
            @click="handleSubmit"
          >
            {{ orderItem.itemMeta.parter && !ticketQuantity ? 'Izbriši' : 'Dodaj' }}
          </main-button>
          <p v-if="numberOfNeededTickets > 0" class="remaining-tickets">
            *Odaberi još min. <b>{{ numberOfNeededTickets }} ulaznica</b>
          </p>
        </div>
      </div>
    </div>
  </v-dialog>
</template>

<script>
export default {
  name: 'floor-plan-element-dialog',
  props: {
    openDialog: {
      type: Boolean,
      default: false,
    },
    orderItem: {
      type: Object,
      default: () => {},
    },
    initialQuantity: {
      type: Number,
      default: 1,
    },
    quantityLimit: {
      type: Number,
      default: 10,
    },
    currentSelectedAmount: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      ticketQuantity: this.initialQuantity,
    }
  },
  computed: {
    numberOfNeededTickets() {
      if (this.ticketQuantity === 0) return false

      return (this.orderItem.itemMeta.min || 0) - this.ticketQuantity
    },
    disableIncreaseButton() {
      if (this.orderItem.itemMeta.parter) {
        return (
          this.ticketQuantity === parseInt(this.orderItem.quantity) ||
          this.ticketQuantity === this.quantityLimit ||
          this.ticketQuantity + (this.currentSelectedAmount - this.initialQuantity) >=
            this.quantityLimit ||
          (this.orderItem.itemMeta && this.ticketQuantity === this.orderItem.itemMeta.max)
        )
      } else {
        return this.ticketQuantity === this.orderItem.itemMeta.max
      }
    },
  },
  methods: {
    increaseTicketNum() {
      this.ticketQuantity++
    },
    decreaseTicketNum() {
      this.ticketQuantity--
    },
    handleCancelAction() {
      this.$emit('removeTicketFromOrder')
    },
    handleSubmit() {
      this.$emit('addTickets', this.ticketQuantity)
    },
  },
}
</script>

<style scoped>
h2 {
  color: var(--Grey-00, #333);
  font-variant-numeric: lining-nums proportional-nums;
  font-family: Raleway;
  font-size: 24px;
  font-style: normal;
  font-weight: 600;
  line-height: 120%;
  letter-spacing: -0.72px;
}

p {
  color: var(--Grey-10, #333);
  font-family: 'Source Sans Pro';
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 120%;
  margin: 0;
}

.content-container {
  background: #e8e8e8;
  padding: 16px 16px 32px;
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.top-buttons {
  display: flex;
  gap: 20px;
  align-items: center;
}

.bottom-buttons {
  display: flex;
  justify-content: space-between;
  gap: 0.5rem;
}

.ticket-number {
  font-family: Source Sans Pro, serif;
  font-style: normal;
  font-weight: 600;
  font-size: 22px;
  user-select: none;
  display: flex;
  align-items: center;
  color: #333333;
}

#add-button-wrapper {
  display: flex;
  width: 100%;
  flex-direction: column;
  align-items: center;
}

.remaining-tickets {
  color: var(--Grey-10, #666);
  font-size: 14px;
}

.ticket-container {
  background: #fff;
  width: 100%;
  border-radius: 48px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px 16px 16px 24px;
  color: white;
  margin: 32px 0;
}

.cursor-pointer {
  cursor: pointer;
  user-select: none;
}

.price {
  color: var(--Grey-00, #333);
  font-variant-numeric: lining-nums proportional-nums;
  font-family: 'Source Sans Pro';
  font-size: 20px;
  font-style: normal;
  font-weight: 600;
  line-height: 120%; /* 24px */
  letter-spacing: -0.6px;
  text-transform: uppercase;
}
</style>
